import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import * as XLSX from 'xlsx';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap/modal/modal';
// import { ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap/modal/modal-dismiss-reasons';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { interval } from 'rxjs';

@Component({
  selector: 'app-parts',
  templateUrl: './parts.component.html',
  styleUrls: ['./parts.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PartsComponent implements OnInit {

  isShownError: boolean = true;
  isShownError1: boolean = true;
  isShownSuccess: boolean = true;
  Status: boolean = true;
  ErrorMsg: string;
  SuccessMsg: string;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean = true;
  isShownActive: Boolean = true;
  isShownExportTable: boolean = true;
  public searchText: string;

  prefix: string;
  suffix: string;
  Base: string;
  Partnumber: string;
  EffectiveDate: string;
  PartName: string;
  ShortDesc: string;
  LongDesc: string;
  HSCOde: string;
  Coo: string;
  SupName: string;
  Address1: string;
  Address2: string;
  City: string;
  State: string;
  country: string;
  Zip: string;
  ContactName: string;
  Title: string;
  Phone: string;
  Email: string;
  vat: string;
  Currency: string;
  UnitPrice: string;
  UOM: string;
  Restrictions: string;
  Cnotn: string;
  CNtnSiNo: string;
  CusDtyRt: string;
  AntiDmNotn: string;
  AntiDmSiNo: string;
  AntiUnitPrice: string;
  ENotn: string;
  ENotnSiNo: string;
  ExcDtyRt: string; SpExDtyRt: string; HCVDRt: string; ECCRt: string;
  SHECCRt: string; CECRt: string; CSHECRt: string; SWSRt: string;
  IGSTNOtn: string; IGSTtnSiNo: string; IGSTRt: string;
  GSTNOtn: string; GSTtnSiNo: string; GSTRt: string;
  FTANotn: string; FTASiNo: string; Sims: string;
  FTAPortYes: boolean;
  FTAPortNo: boolean;
  SIMSPartYes: boolean;
  SIMSPartNo: boolean;
  PartsExport = [] as any;
  EditedPart = [] as any;
  EditedPartId: string;
  closeResult = '';
  countrys = [];
  countryid: string;
  countrycode: string;
  currency = [];
  currencyId: string;
  currencycode: string;
  exportpart = [];
  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;
  sOnboardingId: string;
  sOldOnboadId:string;

  displayedColumns: string[] = ['sno', 'partno', 'shortdesc', 'hscode', 'coo', 'unitPrice', 'effectiveDate', 'enddate', 'status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  displayedColumns1: string[] = ['sno', 'partno', 'shortdesc', 'hscode', 'coo', 'unitPrice', 'effectiveDate', 'enddate', 'status'];
  dataSource1: MatTableDataSource<any[]>;
  @ViewChild('paginator1', { static: true }) paginator1: MatPaginator;
  @ViewChild('sort1', { static: true }) sort1: MatSort;
  @ViewChild('TABLE1') table1: ElementRef;


  constructor(private modalService: NgbModal, private http: HttpClient) { }

  ngOnInit(): void {
    this.vRead = localStorage.getItem('PartsRead');
    this.vWrite = localStorage.getItem('PartsWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';
    if (this.vWrite != undefined && this.vWrite != "") {
      if (this.vWrite == "True")
        this.isShownWrite = false;
    }
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
    }
    this.BindPartsGrid();
    this.BindPartExport();
    this.BindCountryDDL();
    this.BindcurrencyDDL();
    interval(3000).subscribe(x => {
      this.sOnboardingId = localStorage.getItem('OnboardingId');
      if (this.sOldOnboadId != this.sOnboardingId) {
        this.BindPartsGrid();
    this.BindPartExport();
    this.BindCountryDDL();
    this.BindcurrencyDDL();
      this.sOldOnboadId=this.sOnboardingId;
      }
    });
  }
  ngAfterViewInit(): void {
    this.dataSource1.paginator = this.paginator1;
  }
  BindCountryDDL() {
    var value = this.http.get(environment.apiUrl + 'Part/GetCountryDDL').toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          debugger;
          this.countrys = data;
          this.countryid = "0";
        }
        else {
        };
      });
  }
  

  BindcurrencyDDL() {
    var value = this.http.get(environment.apiUrl + 'Part/GetCurrencyDDL').toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          debugger;
          this.currency = data;
          this.currencyId = "0";
        }
        else {
        };
      });
  }



  open(content) {
    debugger;
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return;
    }
    var vprefix = this.prefix;
    var vpartNumber = this.Base;
    var vsuffix = this.suffix;

    if (vpartNumber == undefined || vpartNumber == "" || vpartNumber == "0") {
      this.isShownError1 = false;
      this.ErrorMsg = "Please Enter Part Number.";
      return false;
    }

    if (vprefix == undefined || vprefix == "" || vprefix == "0") {
      vprefix = "";
    }

    if (vsuffix == undefined || vsuffix == "" || vsuffix == "0") {
      vprefix = "";
    }

    var pnum = vprefix + "-" + vpartNumber + "-" + vsuffix;
    this.Partnumber = pnum;
    let params = new HttpParams();
    params = params.append('dPartnumber', this.Partnumber);
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'Part/GetPartsHistory', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource1 = new MatTableDataSource(data);
        this.dataSource1.data = data;
        this.dataSource1.paginator = this.paginator1;
        this.dataSource1.sort = this.sort1;
      });



    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  SubmitParts() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return false;
    }
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.Status = false;
    var vprefix = this.prefix;
    var vpartNumber = this.Base;
    var vsuffix = this.suffix;
    var vEffectiveDate = this.EffectiveDate;
    var vPartName = this.PartName;
    var vShortDesc = this.ShortDesc;
    var vLongDesc = this.LongDesc;
    var vHSCOde = this.HSCOde;
    var vCoo = this.Coo;
    var vSupName = this.SupName;
    var vAddress1 = this.Address1;
    var vAddress2 = this.Address2;
    var vCity = this.City;
    var vState = this.State;
    var vCountry = this.country;
    var vZip = this.Zip;
    var vContactName = this.ContactName;
    var vTitle = this.Title;
    var vPhone = this.Phone;
    var vEmail = this.Email;
    var vvat = this.vat;
    var vCurrency = this.Currency;
    var vUnitPrice = this.UnitPrice;
    var vUOM = this.UOM;
    var vRestrictions = this.Restrictions;
    var vCnotn = this.Cnotn;
    var vCNtnSiNo = this.CNtnSiNo;
    var vCusDtyRt = this.CusDtyRt;
    var vAntiDmNotn = this.AntiDmNotn;
    var vAntiDmSiNo = this.AntiDmSiNo;
    var vAntiUnitPrice = this.AntiUnitPrice;
    var vENotn = this.ENotn;
    var vENotnSiNo = this.ENotnSiNo;
    var vExcDtyRt = this.ExcDtyRt;
    var vSpExDtyRt = this.SpExDtyRt;
    var vHCVDRt = this.HCVDRt;
    var vECCRt = this.ECCRt;
    var vSHECCRt = this.SHECCRt;
    var vCECRt = this.CECRt;
    var vCSHECRt = this.CSHECRt;
    var vSWSRt = this.SWSRt;
    var vIGSTNOtn = this.IGSTNOtn;
    var vIGSTtnSiNo = this.IGSTtnSiNo;
    var vIGSTRt = this.IGSTRt;
    var vGSTNOtn = this.GSTNOtn;
    var vGSTtnSiNo = this.GSTtnSiNo;
    var vGSTRt = this.GSTRt;
    var vFTANotn = this.FTANotn;
    var vFTASiNo = this.FTASiNo;
    var vSims = this.Sims;
    debugger;


    if (vpartNumber == undefined || vpartNumber == "" || vpartNumber == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Base Number.";
      return false;
    }

    if (vprefix == undefined || vprefix == "" || vprefix == "0") {
      vprefix = "";
    }

    if (vsuffix == undefined || vsuffix == "" || vsuffix == "0") {
      vprefix = "";
    }

    var pnum = vprefix + "-" + vpartNumber + "-" + vsuffix;
    this.Partnumber = pnum;
    debugger;

    if (vEffectiveDate == undefined || vEffectiveDate == "" || vEffectiveDate == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Effective Date.";
      return false;
    }

    if (vPartName == undefined || vPartName == "" || vPartName == "0") {
      this.PartName = "";
    }

    if (vShortDesc == undefined || vShortDesc == "" || vShortDesc == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Short Description.";
      return false;
    }

    if (vLongDesc == undefined || vLongDesc == "" || vLongDesc == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Long Description.";
      return false;
    }

    if (vHSCOde.length < 8) {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Minimum 8 digit HS Code.";
      return false;
    }
    if (vHSCOde == undefined || vHSCOde == "" || vHSCOde == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter HS Code.";
      return false;
    }

    if (vCoo == undefined || vCoo == "" || vCoo == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Country of Origin.";
      return false;
    }

    if (vSupName == undefined || vSupName == "" || vSupName == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Supplier Name.";
      return false;
    }

    if (vAddress1 == undefined || vAddress1 == "" || vAddress1 == "0") {
      this.Address1 = "";
    }

    if (vAddress2 == undefined || vAddress2 == "" || vAddress2 == "0") {
      this.Address2 = "";
    }

    if (vCity == undefined || vCity == "" || vCity == "0") {
      this.City = "";
    }

    if (vState == undefined || vState == "" || vState == "0") {
      this.State = "";
    }

    if (vCountry == undefined || vCountry == "" || vCountry == "0") {
      this.countrycode = "";
    }

    if (vZip == undefined || vZip == "" || vZip == "0") {
      this.Zip = "";
    }

    if (vContactName == undefined || vContactName == "" || vContactName == "0") {
      this.ContactName = "";
    }
    if (vTitle == undefined || vTitle == "" || vTitle == "0") {
      this.Title = "";
    }

    if (vPhone == undefined || vPhone == "" || vPhone == "0") {
      this.Phone = "";
    }

    if (vEmail == undefined || vEmail == "" || vEmail == "0") {
      this.Email = "";
    }

    if (vvat == undefined || vvat == "" || vvat == "0") {
      this.vat = "";
    }

    if (vCurrency == undefined || vCurrency == "" || vCurrency == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Currency.";
      return false;
    }

    if (vUnitPrice == undefined || vUnitPrice == "" || vUnitPrice == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Unit Price.";
      return false;
    }

    if (vUOM == undefined || vUOM == "" || vUOM == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter UOM.";
      return false;
    }

    if (vRestrictions == undefined || vRestrictions == "" || vRestrictions == "0") {
     this.Restrictions="";
    }


    if (vCnotn == undefined || vCnotn == "") {
      this.Cnotn = "";
      if (vCusDtyRt == undefined || vCusDtyRt == "") {
        this.CusDtyRt = "0";
      }
    }
    else {
      if (vCusDtyRt == undefined || vCusDtyRt == "") {
        this.isShownError = false;
        this.ErrorMsg = "Please Enter CusDty Rt.";
        return false;
      }
    }

    if (vCNtnSiNo == undefined || vCNtnSiNo == "" || vCNtnSiNo == "0") {
      this.CNtnSiNo = "";
    }

    if (vAntiDmNotn == undefined || vAntiDmNotn == "") {     
        this.AntiDmNotn = "";      
      if (vAntiUnitPrice == undefined || vAntiUnitPrice == "") {
        this.AntiUnitPrice = "0";
      }     
    }
    else {
      if (vAntiUnitPrice == undefined || vAntiUnitPrice == "") {
        this.isShownError = false;
        this.ErrorMsg = "Please Enter AntiDm Unit Price.";
        return false;
      }
    }
    if (vAntiDmSiNo == undefined || vAntiDmSiNo == "" || vAntiDmSiNo == "0") {
      this.AntiDmSiNo = "";
    }


    if (vENotn == undefined || vENotn == "" ) {     
        this.ENotn = "";      
      if (vExcDtyRt == undefined || vExcDtyRt == "") {
        this.ExcDtyRt = "0";
      }     
    }
    else {
      if (vENotn == undefined || vENotn == "") {
        this.isShownError = false;
        this.ErrorMsg = "Please Enter Ex Dty Rt.";
        return false;
      }
    }

    if (vENotnSiNo == undefined || vENotnSiNo == "" || vENotnSiNo == "0") {
      this.ENotnSiNo = "";
    }



    if (vSpExDtyRt == undefined || vSpExDtyRt == "") {
      this.SpExDtyRt = "0";
    }

    if (vHCVDRt == undefined || vHCVDRt == "") {
      this.HCVDRt = "0";
    }

    if (vECCRt == undefined || vECCRt == "") {
      this.ECCRt = "0";
    }

    if (vSHECCRt == undefined || vSHECCRt == "") {
      this.SHECCRt = "0";
    }

    if (vCECRt == undefined || vCECRt == "") {
      this.CECRt = "0";
    }

    if (vCSHECRt == undefined || vCSHECRt == "") {
      this.CSHECRt = "0";
    }

    if (vSWSRt == undefined || vSWSRt == "") {
      this.SWSRt = "0";
    }

    if (vIGSTNOtn == undefined || vIGSTNOtn == "" || vIGSTNOtn == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter IGST NOtn.";
      return false;
    }

    if (vIGSTtnSiNo == undefined || vIGSTtnSiNo == "" || vIGSTtnSiNo == "0") {
      this.IGSTtnSiNo = "";
    }

    if (vIGSTRt == undefined || vIGSTRt == "" || vIGSTRt == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter IGSTRt.";
      return false;
    }

    if (vGSTNOtn == undefined || vGSTNOtn == "" || vGSTNOtn == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter GSTNOtn.";
      return false;
    }

    if (vGSTtnSiNo == undefined || vGSTtnSiNo == "" || vGSTtnSiNo == "0") {
      this.GSTtnSiNo = "";
    }

    if (vGSTRt == undefined || vGSTRt == "" || vGSTRt == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter GSTRt.";
      return false;
    }

    if (this.FTAPortYes == true) {
      if (vFTANotn == undefined || vFTANotn == "" || vFTANotn == "0") {
        this.isShownError = false;
        this.ErrorMsg = "Please Enter FTA Notn.";
        return false;
      }

      if (vFTASiNo == undefined || vFTASiNo == "" || vFTASiNo == "0") {
        this.isShownError = false;
        this.ErrorMsg = "Please Enter FTA SlNo.";
        return false;
      }
    }
    else {
      if (vFTANotn == undefined || vFTANotn == "" || vFTANotn == "0") {
        this.FTANotn = "";
      }

      if (vFTASiNo == undefined || vFTASiNo == "" || vFTASiNo == "0") {
        this.FTASiNo = "";
      }
    }

    if (this.SIMSPartYes == true) {
      if (vSims == undefined || vSims == "" || vSims == "0") {
        this.isShownError = false;
        this.ErrorMsg = "Please Enter Sims.";
        return false;
      }
    }
    else {
      if (vSims == undefined || vSims == "" || vSims == "0") {
        this.Sims = "";
      }
    }


    let params = new HttpParams();
    params = params.append('dPartnumber', this.Partnumber);
    params = params.append('dEffectiveDate', this.EffectiveDate);
    params = params.append('dPartName', this.PartName);
    params = params.append('dShortDesc', this.ShortDesc);
    params = params.append('dLongDesc', this.LongDesc);
    params = params.append('dHSCOde', this.HSCOde);
    params = params.append('dCoo', this.Coo);
    params = params.append('dSupName', this.SupName);
    params = params.append('dAddress1', this.Address1);
    params = params.append('dAddress2', this.Address2);
    params = params.append('dCity', this.City);
    params = params.append('dState', this.State);
    params = params.append('dCountry', this.country);
    params = params.append('dZip', this.Zip);
    params = params.append('dContactName', this.ContactName);
    params = params.append('dTitle', this.Title);
    params = params.append('dPhone', this.Phone);
    params = params.append('dEmail', this.Email);
    params = params.append('dvat', this.vat);
    params = params.append('dCurrency', this.Currency);
    params = params.append('dUnitPrice', this.UnitPrice);
    params = params.append('dUOM', this.UOM);
    params = params.append('dRestrictions', this.Restrictions);
    params = params.append('dCnotn', this.Cnotn);
    params = params.append('dCNtnSiNo', this.CNtnSiNo);
    params = params.append('dCusDtyRt', this.CusDtyRt);
    params = params.append('dAntiDmNotn', this.AntiDmNotn);
    params = params.append('dAntiDmSiNo', this.AntiDmSiNo);
    params = params.append('dAntiUnitPrice', this.AntiUnitPrice);
    params = params.append('dENotn', this.ENotn);
    params = params.append('dENotnSiNo', this.ENotnSiNo);
    params = params.append('dExcDtyRt', this.ExcDtyRt);
    params = params.append('dSpExDtyRt', this.SpExDtyRt);
    params = params.append('dHCVDRt', this.HCVDRt);
    params = params.append('dECCRt', this.ECCRt);
    params = params.append('dSHECCRt', this.SHECCRt);
    params = params.append('dCECRt', this.CECRt);
    params = params.append('dCSHECRt', this.CSHECRt);
    params = params.append('dSWSRt', this.SWSRt);
    params = params.append('dIGSTNOtn', this.IGSTNOtn);
    params = params.append('dIGSTtnSiNo', this.IGSTtnSiNo);
    params = params.append('dIGSTRt', this.IGSTRt);
    params = params.append('dGSTNOtn', this.GSTNOtn);
    params = params.append('dGSTtnSiNo', this.GSTtnSiNo);
    params = params.append('dGSTRt', this.GSTRt);
    params = params.append('dFTANotn', this.FTANotn);
    params = params.append('dFTASiNo', this.FTASiNo);
    params = params.append('dSims', this.Sims);
    params = params.append('iOnboardingId', this.sOnboardingId);
    debugger;
    var value = this.http.get(environment.apiUrl + 'Part/InsertParts', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.isShownSuccess = false;
        this.SuccessMsg = "Part Master Added."
        var countrycode = data;
        this.Partnumber = "";
        this.prefix = "";
        this.Base = "";
        this.suffix = "";
        this.EffectiveDate = "";
        this.PartName = "";
        this.ShortDesc = "";
        this.LongDesc = "";
        this.HSCOde = "";
        this.Coo = "";
        this.SupName = "";
        this.Address1 = "";
        this.Address2 = "";
        this.City = "";
        this.State = "";
        this.country = "";
        this.Zip = "";
        this.ContactName = "";
        this.Title = "";
        this.Phone = "";
        this.Email = "";
        this.vat = "";
        this.Currency = "";
        this.UnitPrice = "";
        this.UOM = "";
        this.Restrictions = "";
        this.Cnotn = "";
        this.CNtnSiNo = "";
        this.CusDtyRt = "";
        this.AntiDmNotn = "";
        this.AntiDmSiNo = "";
        this.AntiUnitPrice = "";
        this.ENotn = "";
        this.ENotnSiNo = "";
        this.ExcDtyRt = "";
        this.SpExDtyRt = "";
        this.HCVDRt = "";
        this.ECCRt = "";
        this.SHECCRt = "";
        this.CECRt = "";
        this.CSHECRt = "";
        this.SWSRt = "";
        this.IGSTNOtn = "";
        this.IGSTtnSiNo = "";
        this.IGSTRt = "";
        this.GSTNOtn = "";
        this.GSTtnSiNo = "";
        this.GSTRt = "";
        this.FTANotn = "";
        this.FTASiNo = "";
        this.Sims = "";

        this.BindPartsGrid();
        this.BindPartExport();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
       else if (vErrorMsg1 == "Success") {
        this.isShownSuccess = false;
        this.SuccessMsg = "Part Master Added."
        var countrycode = data;
        this.Partnumber = "";
        this.prefix = "";
        this.Base = "";
        this.suffix = "";
        this.EffectiveDate = "";
        this.PartName = "";
        this.ShortDesc = "";
        this.LongDesc = "";
        this.HSCOde = "";
        this.Coo = "";
        this.SupName = "";
        this.Address1 = "";
        this.Address2 = "";
        this.City = "";
        this.State = "";
        this.country = "";
        this.Zip = "";
        this.ContactName = "";
        this.Title = "";
        this.Phone = "";
        this.Email = "";
        this.vat = "";
        this.Currency = "";
        this.UnitPrice = "";
        this.UOM = "";
        this.Restrictions = "";
        this.Cnotn = "";
        this.CNtnSiNo = "";
        this.CusDtyRt = "";
        this.AntiDmNotn = "";
        this.AntiDmSiNo = "";
        this.AntiUnitPrice = "";
        this.ENotn = "";
        this.ENotnSiNo = "";
        this.ExcDtyRt = "";
        this.SpExDtyRt = "";
        this.HCVDRt = "";
        this.ECCRt = "";
        this.SHECCRt = "";
        this.CECRt = "";
        this.CSHECRt = "";
        this.SWSRt = "";
        this.IGSTNOtn = "";
        this.IGSTtnSiNo = "";
        this.IGSTRt = "";
        this.GSTNOtn = "";
        this.GSTtnSiNo = "";
        this.GSTRt = "";
        this.FTANotn = "";
        this.FTASiNo = "";
        this.Sims = "";

        this.BindPartsGrid();
        this.BindPartExport();
        return false;
        }
        else if (vErrorMsg1 == "Exist") {
          this.isShownError = false;
          this.ErrorMsg = "Part Master Record Already Exist.";
          return false;
        }
        else {
        }
      });

  }

  EditPart(item: any) {
    this.isShownSaveBtn = true;
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.Status = true;
    this.isShownSuccess = true;
    this.isShownError = true;
    this.isShownError1 = true;
    this.EditedPart = item;
    debugger;
    var vpartId = this.EditedPart.partId;
    var vpartNumber = this.EditedPart.partno;
    var vEffectiveDate = this.EditedPart.effectiveDate1;
    var vPartName = this.EditedPart.partName;
    var vShortDesc = this.EditedPart.shortdesc;
    var vLongDesc = this.EditedPart.longdesc;
    var vHSCOde = this.EditedPart.hscode;
    var vCoo = this.EditedPart.coo;
    var vSupName = this.EditedPart.suppliername;
    var vAddress1 = this.EditedPart.address1;
    var vAddress2 = this.EditedPart.address2;
    var vCity = this.EditedPart.city;
    var vState = this.EditedPart.state;
    var vCountry = this.EditedPart.country;
    var vZip = this.EditedPart.zip;
    var vContactName = this.EditedPart.contactname;
    var vTitle = this.EditedPart.title;
    var vPhone = this.EditedPart.phone;
    var vEmail = this.EditedPart.email;
    var vvat = this.EditedPart.vat;
    var vCurrency = this.EditedPart.currency;
    var vUnitPrice = this.EditedPart.unitPrice;
    var vUOM = this.EditedPart.uom;
    var vRestrictions = this.EditedPart.restrictions;
    var vCnotn = this.EditedPart.cnotn;
    var vCNtnSiNo = this.EditedPart.cnotnSiNo;
    var vCusDtyRt = this.EditedPart.cusDtyRt;
    var vAntiDmNotn = this.EditedPart.antdmNotn;
    var vAntiDmSiNo = this.EditedPart.antidmNotSiNo;
    var vAntiUnitPrice = this.EditedPart.antidmUnitPrice;
    var vENotn = this.EditedPart.enotn;
    var vENotnSiNo = this.EditedPart.enotnSiNo;
    var vExcDtyRt = this.EditedPart.excDtyRt;
    var vSpExDtyRt = this.EditedPart.spexDytRt;
    var vHCVDRt = this.EditedPart.hcvdrt;
    var vECCRt = this.EditedPart.eccrt;
    var vSHECCRt = this.EditedPart.sheccrt;
    var vCECRt = this.EditedPart.cecrt;
    var vCSHECRt = this.EditedPart.cshecrt;
    var vSWSRt = this.EditedPart.swsrt;
    var vIGSTNOtn = this.EditedPart.igstnotn;
    var vIGSTtnSiNo = this.EditedPart.igstnotnSno;
    var vIGSTRt = this.EditedPart.igstrt;
    var vGSTNOtn = this.EditedPart.gstcnotn;
    var vGSTtnSiNo = this.EditedPart.gstcnotnSino;
    var vGSTRt = this.EditedPart.gstcrt;
    debugger;
    var vFTANotn = this.EditedPart.ftanotn;
    var vFTASiNo = this.EditedPart.ftasno;
    var vSims = this.EditedPart.simsremarks;


    if (vpartNumber != null || vpartNumber != undefined || vpartNumber != "") {
      const string = vpartNumber;
      const string1 = "-";
      if(string.includes(string1))
      {
        var Stype = vpartNumber.split("-");
        debugger;
        for (var i = 0; i < Stype.length; i++) {
          if (i == 0) {
            this.prefix = Stype[0].toString();
          }
          else if (i == 1) {
            this.Base = Stype[1].toString();
          }
          else if (i == 2) {
            this.suffix = Stype[2].toString();
          }
        }
      }
      else
      {
        this.Base = vpartNumber;
      }
      
    }
    debugger;
    this.EditedPartId = vpartId;
    this.PartName = vPartName;
    debugger;
    // this.EffectiveDate = new Date(vEffectiveDate).toISOString().split('T')[0];
    this.EffectiveDate = new Date(new Date(vEffectiveDate).setDate(new Date(vEffectiveDate).getDate() + 1)).toISOString().split('T')[0];
    //this.EffectiveDate = vEffectiveDate; 
    this.ShortDesc = vShortDesc;
    this.LongDesc = vLongDesc;
    this.HSCOde = vHSCOde;
    this.Coo = vCoo;
    this.SupName = vSupName;
    this.Address1 = vAddress1;
    this.Address2 = vAddress2;
    this.City = vCity;
    this.State = vState;
    this.country = vCountry;
    this.Zip = vZip;
    this.ContactName = vContactName;
    this.Title = vTitle;
    this.Phone = vPhone;
    this.Email = vEmail;
    this.vat = vvat;
    this.Currency = vCurrency;
    this.UnitPrice = vUnitPrice;
    this.UOM = vUOM;
    this.Restrictions = vRestrictions;
    this.Cnotn = vCnotn;
    this.CNtnSiNo = vCNtnSiNo;
    if(vCusDtyRt == "0" || vCusDtyRt == 0)
    {
      this.CusDtyRt="";
    }
    else
    {
      this.CusDtyRt = vCusDtyRt;
    }    
    this.AntiDmNotn = vAntiDmNotn;
    this.AntiDmSiNo = vAntiDmSiNo;
if(vAntiUnitPrice == "0" || vAntiUnitPrice == 0)
{
  this.AntiUnitPrice="";
}
else{
  this.AntiUnitPrice = vAntiUnitPrice;
}    
    this.ENotn = vENotn;
    this.ENotnSiNo = vENotnSiNo;
    if(vExcDtyRt == "0" || vExcDtyRt == 0)
    {
      this.ExcDtyRt="";
    }
    else
    {
      this.ExcDtyRt = vExcDtyRt;
    }    
    if(vSpExDtyRt == "0" || vSpExDtyRt == 0)
    {
      this.SpExDtyRt="";
    }
    else
    {
      this.SpExDtyRt = vSpExDtyRt;
    }
    if(vHCVDRt == "0" || vHCVDRt == 0)
    {
      this.HCVDRt="";
    }
    else
    {
      this.HCVDRt = vHCVDRt;
    }    
    if(vECCRt == "0" || vECCRt == 0)
    {
      this.ECCRt="";
    }
    else
    {
      this.ECCRt = vECCRt;
    }
    if(vSHECCRt == "0" || vSHECCRt == 0)
    {
      this.SHECCRt="";
    }   
    else{
      this.SHECCRt = vSHECCRt;
    }    
    if(vCECRt == "0" || vCECRt == 0)
    {
      this.CECRt="";
    } 
    else
    {
      this.CECRt = vCECRt;
    }    
    if(vCSHECRt =="0" || vCSHECRt == 0)
    {
      this.CSHECRt="";
    }
    else
    {
      this.CSHECRt = vCSHECRt;
    }   
    if(vSWSRt =="0" || vSWSRt == 0)
    {
      this.SWSRt="";
    }
    else
    {
      this.SWSRt = vSWSRt;
    }   
    this.IGSTNOtn = vIGSTNOtn;
    this.IGSTtnSiNo = vIGSTtnSiNo;
    if(vIGSTRt == "0" || vIGSTRt == 0)
    {
      this.IGSTRt="";
    }
    else
    {
      this.IGSTRt = vIGSTRt;
    }    
    this.GSTNOtn = vGSTNOtn;
    this.GSTtnSiNo = vGSTtnSiNo;
    if(vGSTRt == "0" || vGSTRt == 0)
    {
      this.GSTRt="";
    }
    else
    {
      this.GSTRt = vGSTRt;
    }   
    this.FTANotn = vFTANotn;
    this.FTASiNo = vFTASiNo;
    this.Sims = vSims;
    var vStatus = this.EditedPart.status;
    debugger;
    if (vStatus == "Active") {
      this.Status = false;
    }
    else {
      this.Status = true;
    }
  }


  UpdateParts() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vprefix = this.prefix;
    var vsuffix = this.suffix;
    var vpartNumber = this.Base;
    var vEffectiveDate = this.EffectiveDate;
    var vPartName = this.PartName;
    var vShortDesc = this.ShortDesc;
    var vLongDesc = this.LongDesc;
    var vHSCOde = this.HSCOde;
    var vCoo = this.Coo;
    var vSupName = this.SupName;
    var vAddress1 = this.Address1;
    var vAddress2 = this.Address2;
    var vCity = this.City;
    var vState = this.State;
    var vCountry = this.country;
    var vZip = this.Zip;
    var vContactName = this.ContactName;
    var vTitle = this.Title;
    var vPhone = this.Phone;
    var vEmail = this.Email;
    var vvat = this.vat;
    var vCurrency = this.Currency;
    var vUnitPrice = this.UnitPrice;
    var vUOM = this.UOM;
    var vRestrictions = this.Restrictions;
    var vCnotn = this.Cnotn;
    var vCNtnSiNo = this.CNtnSiNo;
    var vCusDtyRt = this.CusDtyRt;
    var vAntiDmNotn = this.AntiDmNotn;
    var vAntiDmSiNo = this.AntiDmSiNo;
    var vAntiUnitPrice = this.AntiUnitPrice;
    var vENotn = this.ENotn;
    var vENotnSiNo = this.ENotnSiNo;
    var vExcDtyRt = this.ExcDtyRt;
    var vSpExDtyRt = this.SpExDtyRt;
    var vHCVDRt = this.HCVDRt;
    var vECCRt = this.ECCRt;
    var vSHECCRt = this.SHECCRt;
    var vCECRt = this.CECRt;
    var vCSHECRt = this.CSHECRt;
    var vSWSRt = this.SWSRt;
    var vIGSTNOtn = this.IGSTNOtn;
    var vIGSTtnSiNo = this.IGSTtnSiNo;
    var vIGSTRt = this.IGSTRt;
    var vGSTNOtn = this.GSTNOtn;
    var vGSTtnSiNo = this.GSTtnSiNo;
    var vGSTRt = this.GSTRt;
    var vFTANotn = this.FTANotn;
    var vFTASiNo = this.FTASiNo;
    var vSims = this.Sims;
    debugger;

    if (vpartNumber == undefined || vpartNumber == "" || vpartNumber == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Base Number.";
      return false;
    }

    if (vprefix == undefined || vprefix == "" || vprefix == "0") {
      vprefix = "";
    }

    if (vsuffix == undefined || vsuffix == "" || vsuffix == "0") {
      vsuffix = "";
    }

    var pnum = vprefix + "-" + vpartNumber + "-" + vsuffix;
    this.Partnumber = pnum;
    debugger;

    if (vEffectiveDate == undefined || vEffectiveDate == "" || vEffectiveDate == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Effective Date";
      return false;
    }

    if (vPartName == undefined || vPartName == "" || vPartName == "0") {
      this.PartName = "";
    }

    if (vShortDesc == undefined || vShortDesc == "" || vShortDesc == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Short Description.";
      return false;
    }

    if (vLongDesc == undefined || vLongDesc == "" || vLongDesc == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Long Description.";
      return false;
    }

    if (vHSCOde.length < 8) {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Minimum 8 digit HS Code.";
      return false;
    }
    if (vHSCOde == undefined || vHSCOde == "" || vHSCOde == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter HS Code.";
      return false;
    }

    if (vCoo == undefined || vCoo == "" || vCoo == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Country of Origin.";
      return false;
    }

    if (vSupName == undefined || vSupName == "" || vSupName == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Supplier Name.";
      return false;
    }

    if (vAddress1 == undefined || vAddress1 == "" || vAddress1 == "0") {
      this.Address1 = "";
    }

    if (vAddress2 == undefined || vAddress2 == "" || vAddress2 == "0") {
      this.Address2 = "";
    }

    if (vCity == undefined || vCity == "" || vCity == "0") {
      this.City = "";
    }

    if (vState == undefined || vState == "" || vState == "0") {
      this.State = "";
    }

    if (vCountry == undefined || vCountry == "" || vCountry == "0") {
      this.countrycode = "";
    }

    if (vZip == undefined || vZip == "" || vZip == "0") {
      this.Zip = "";
    }

    if (vContactName == undefined || vContactName == "" || vContactName == "0") {
      this.ContactName = "";
    }
    if (vTitle == undefined || vTitle == "" || vTitle == "0") {
      this.Title = "";
    }

    if (vPhone == undefined || vPhone == "" || vPhone == "0") {
      this.Phone = "";
    }

    if (vEmail == undefined || vEmail == "" || vEmail == "0") {
      this.Email = "";
    }

    if (vvat == undefined || vvat == "" || vvat == "0") {
      this.vat = "";
    }

    if (vCurrency == undefined || vCurrency == "" || vCurrency == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Currency.";
      return false;
    }

    if (vUnitPrice == undefined || vUnitPrice == "" || vUnitPrice == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Unit Price.";
      return false;
    }

    if (vUOM == undefined || vUOM == "" || vUOM == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter UOM.";
      return false;
    }

    if (vRestrictions == undefined || vRestrictions == "" || vRestrictions == "0") {
     this.Restrictions="";
    }

    if (vCnotn == undefined || vCnotn == "") {
      this.Cnotn = "";
      if (vCusDtyRt == undefined || vCusDtyRt == "") {
        this.CusDtyRt = "0";
      }
    }
    else {
      if (vCusDtyRt == undefined || vCusDtyRt == "") {
        this.isShownError = false;
        this.ErrorMsg = "Please Enter CusDty Rt.";
        return false;
      }
    }

    if (vCNtnSiNo == undefined || vCNtnSiNo == "" || vCNtnSiNo == "0") {
      this.CNtnSiNo = "";
    }

    if (vAntiDmNotn == undefined || vAntiDmNotn == "") {     
        this.AntiDmNotn = "";      
      if (vAntiUnitPrice == undefined || vAntiUnitPrice == "") {
        this.AntiUnitPrice = "0";
      }     
    }
    else {
      if (vAntiUnitPrice == undefined || vAntiUnitPrice == "") {
        this.isShownError = false;
        this.ErrorMsg = "Please Enter AntiDm Unit Price.";
        return false;
      }
    }
    if (vAntiDmSiNo == undefined || vAntiDmSiNo == "" || vAntiDmSiNo == "0") {
      this.AntiDmSiNo = "";
    }


    if (vENotn == undefined || vENotn == "" ) {     
        this.ENotn = "";      
      if (vExcDtyRt == undefined || vExcDtyRt == "") {
        this.ExcDtyRt = "0";
      }     
    }
    else {
      if (vENotn == undefined || vENotn == "") {
        this.isShownError = false;
        this.ErrorMsg = "Please Enter Ex Dty Rt.";
        return false;
      }
    }

    if (vENotnSiNo == undefined || vENotnSiNo == "" || vENotnSiNo == "0") {
      this.ENotnSiNo = "";
    }

    if (vSpExDtyRt == undefined || vSpExDtyRt == "") {
      this.SpExDtyRt = "0";
    }

    if (vHCVDRt == undefined || vHCVDRt == "") {
      this.HCVDRt = "0";
    }

    if (vECCRt == undefined || vECCRt == "") {
      this.ECCRt = "0";
    }

    if (vSHECCRt == undefined || vSHECCRt == "") {
      this.SHECCRt = "0";
    }

    if (vCECRt == undefined || vCECRt == "") {
      this.CECRt = "0";
    }

    if (vCSHECRt == undefined || vCSHECRt == "") {
      this.CSHECRt = "0";
    }

    if (vSWSRt == undefined || vSWSRt == "") {
      this.SWSRt = "0";
    }

    if (vIGSTNOtn == undefined || vIGSTNOtn == "" || vIGSTNOtn == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter IGST NOtn.";
      return false;
    }

    if (vIGSTtnSiNo == undefined || vIGSTtnSiNo == "" || vIGSTtnSiNo == "0") {
      this.IGSTtnSiNo = "";
    }

    if (vIGSTRt == undefined || vIGSTRt == "" || vIGSTRt == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter IGSTRt.";
      return false;
    }

    if (vGSTNOtn == undefined || vGSTNOtn == "" || vGSTNOtn == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter GSTNOtn.";
      return false;
    }

    if (vGSTtnSiNo == undefined || vGSTtnSiNo == "" || vGSTtnSiNo == "0") {
      this.GSTtnSiNo = "";
    }

    if (vGSTRt == undefined || vGSTRt == "" || vGSTRt == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter GSTRt.";
      return false;
    }

    if (this.FTAPortYes == true) {
      if (vFTANotn == undefined || vFTANotn == "" || vFTANotn == "0") {
        this.isShownError = false;
        this.ErrorMsg = "Please Enter FTA Notn.";
        return false;
      }

      if (vFTASiNo == undefined || vFTASiNo == "" || vFTASiNo == "0") {
        this.isShownError = false;
        this.ErrorMsg = "Please Enter FTA SlNo.";
        return false;
      }
    }
    else {
      if (vFTANotn == undefined || vFTANotn == "" || vFTANotn == "0") {
        this.FTANotn = "";
      }

      if (vFTASiNo == undefined || vFTASiNo == "" || vFTASiNo == "0") {
        this.FTASiNo = "";
      }
    }

    if (this.SIMSPartYes == true) {
      if (vSims == undefined || vSims == "" || vSims == "0") {
        this.isShownError = false;
        this.ErrorMsg = "Please Enter Sims.";
        return false;
      }
    }
    else {
      if (vSims == undefined || vSims == "" || vSims == "0") {
        this.Sims = "";
      }
    }
    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";

    let params = new HttpParams();
    params = params.append('iPartId', this.EditedPartId);
    params = params.append('dPartnumber', this.Partnumber);
    params = params.append('dEffectiveDate', this.EffectiveDate);
    params = params.append('dPartName', this.PartName);
    params = params.append('dShortDesc', this.ShortDesc);
    params = params.append('dLongDesc', this.LongDesc);
    params = params.append('dHSCOde', this.HSCOde);
    params = params.append('dCoo', this.Coo);
    params = params.append('dSupName', this.SupName);
    params = params.append('dAddress1', this.Address1);
    params = params.append('dAddress2', this.Address2);
    params = params.append('dCity', this.City);
    params = params.append('dState', this.State);
    params = params.append('dCountry', this.country);
    params = params.append('dZip', this.Zip);
    params = params.append('dContactName', this.ContactName);
    params = params.append('dTitle', this.Title);
    params = params.append('dPhone', this.Phone);
    params = params.append('dEmail', this.Email);
    params = params.append('dvat', this.vat);
    params = params.append('dCurrency', this.Currency);
    params = params.append('dUnitPrice', this.UnitPrice);
    params = params.append('dUOM', this.UOM);
    params = params.append('dRestrictions', this.Restrictions);
    params = params.append('dCnotn', this.Cnotn);
    params = params.append('dCNtnSiNo', this.CNtnSiNo);
    params = params.append('dCusDtyRt', this.CusDtyRt);
    params = params.append('dAntiDmNotn', this.AntiDmNotn);
    params = params.append('dAntiDmSiNo', this.AntiDmSiNo);
    params = params.append('dAntiUnitPrice', this.AntiUnitPrice);
    params = params.append('dENotn', this.ENotn);
    params = params.append('dENotnSiNo', this.ENotnSiNo);
    params = params.append('dExcDtyRt', this.ExcDtyRt);
    params = params.append('dSpExDtyRt', this.SpExDtyRt);
    params = params.append('dHCVDRt', this.HCVDRt);
    params = params.append('dECCRt', this.ECCRt);
    params = params.append('dSHECCRt', this.SHECCRt);
    params = params.append('dCECRt', this.CECRt);
    params = params.append('dCSHECRt', this.CSHECRt);
    params = params.append('dSWSRt', this.SWSRt);
    params = params.append('dIGSTNOtn', this.IGSTNOtn);
    params = params.append('dIGSTtnSiNo', this.IGSTtnSiNo);
    params = params.append('dIGSTRt', this.IGSTRt);
    params = params.append('dGSTNOtn', this.GSTNOtn);
    params = params.append('dGSTtnSiNo', this.GSTtnSiNo);
    params = params.append('dGSTRt', this.GSTRt);
    params = params.append('dFTANotn', this.FTANotn);
    params = params.append('dFTASiNo', this.FTASiNo);
    params = params.append('dSims', this.Sims);
    params = params.append('istatus', vStatus);

    debugger;
    var value = this.http.get(environment.apiUrl + 'Part/UpdateParts', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var countrycode = data;
        this.isShownSuccess = false;
        this.SuccessMsg = "Part Master Updated."
        this.Partnumber = "";
        this.prefix = "";
        this.Base = "";
        this.suffix = "";
        this.EffectiveDate = "";
        this.PartName = "";
        this.ShortDesc = "";
        this.LongDesc = "";
        this.HSCOde = "";
        this.Coo = "";
        this.SupName = "";
        this.Address1 = "";
        this.Address2 = "";
        this.City = "";
        this.State = "";
        this.country = "";
        this.Zip = "";
        this.ContactName = "";
        this.Title = "";
        this.Phone = "";
        this.Email = "";
        this.vat = "";
        this.Currency = "";
        this.UnitPrice = "";
        this.UOM = "";
        this.Restrictions = "";
        this.Cnotn = "";
        this.CNtnSiNo = "";
        this.CusDtyRt = "";
        this.AntiDmNotn = "";
        this.AntiDmSiNo = "";
        this.AntiUnitPrice = "";
        this.ENotn = "";
        this.ENotnSiNo = "";
        this.ExcDtyRt = "";
        this.SpExDtyRt = "";
        this.HCVDRt = "";
        this.ECCRt = "";
        this.SHECCRt = "";
        this.CECRt = "";
        this.CSHECRt = "";
        this.SWSRt = "";
        this.IGSTNOtn = "";
        this.IGSTtnSiNo = "";
        this.IGSTRt = "";
        this.GSTNOtn = "";
        this.GSTtnSiNo = "";
        this.GSTRt = "";
        this.FTANotn = "";
        this.FTASiNo = "";
        this.Sims = "";
        this.Status = false;
        this.isShownSaveBtn = false;
        this.isShownUpdateBtn = true;
        this.isShownActive = true;
        this.BindPartsGrid();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Update Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });
  }

  ClearParts() {
    this.isShownError = true;
    this.isShownError1 = true;
    this.isShownSuccess = true;
    this.isShownActive = true;
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn = true;
    this.Status = false;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.Partnumber = "";
    this.prefix = "";
    this.Base = "";
    this.suffix = "";
    this.EffectiveDate = "";
    this.PartName = "";
    this.ShortDesc = "";
    this.LongDesc = "";
    this.HSCOde = "";
    this.Coo = "";
    this.SupName = "";
    this.Address1 = "";
    this.Address2 = "";
    this.City = "";
    this.State = "";
    this.country = "";
    this.Zip = "";
    this.ContactName = "";
    this.Title = "";
    this.Phone = "";
    this.Email = "";
    this.vat = "";
    this.Currency = "";
    this.UnitPrice = "";
    this.UOM = "";
    this.Restrictions = "";
    this.Cnotn = "";
    this.CNtnSiNo = "";
    this.CusDtyRt = "";
    this.AntiDmNotn = "";
    this.AntiDmSiNo = "";
    this.AntiUnitPrice = "";
    this.ENotn = "";
    this.ENotnSiNo = "";
    this.ExcDtyRt = "";
    this.SpExDtyRt = "";
    this.HCVDRt = "";
    this.ECCRt = "";
    this.SHECCRt = "";
    this.CECRt = "";
    this.CSHECRt = "";
    this.SWSRt = "";
    this.IGSTNOtn = "";
    this.IGSTtnSiNo = "";
    this.IGSTRt = "";
    this.GSTNOtn = "";
    this.GSTtnSiNo = "";
    this.GSTRt = "";
    this.FTANotn = "";
    this.FTASiNo = "";
    this.Sims = "";
  }

  ViewHistory() {
  }


  Checkcrncy(event: any) {
    var vCurrencycode = this.Currency;
    debugger;
    let params = new HttpParams();
    params = params.append('dcurrency', vCurrencycode);
    var value = this.http.get(environment.apiUrl + 'Currency/CheckCurrency', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed" || vErrorMsg1 =="") {
          this.isShownError = false;
          this.ErrorMsg = "Currency Code doesn't exists. Please select a Valid Currency Code from the list.";
          this.Currency = "";
          return false;
        }
        else {
          this.isShownError=true;
        }   
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed" || vErrorMsg1 == "") {
          this.isShownError = false;
          this.ErrorMsg = "Currency Code doesn't exists. Please select a Valid Currency Code from the list.";
          this.Currency="";
          return false;
        }
        else {
         this.isShownError=true;
        }   
      });
  }


  Checkcnty(event: any) {
    var vcountryname = this.country;
    debugger;
    let params = new HttpParams();
    params = params.append('dcountryname', vcountryname);
    var value = this.http.get(environment.apiUrl + 'Currency/CheckCountry', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed" || vErrorMsg1 =="") {
          this.isShownError = false;
          this.ErrorMsg = "Country Name doesn't exists. Please select a Valid Country Name from the list.";
          this.country = "";
          return false;
        }
        else {
          this.isShownError=true;
        }   
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed" || vErrorMsg1 == "") {
          this.isShownError = false;
          this.ErrorMsg = "Country Name doesn't exists. Please select a Valid Country Name from the list.";
          this.country="";
          return false;
        }
        else {
         this.isShownError=true;
        }   
      });
  }

  Checkcoo(event: any) {
    var vcoo = this.Coo;
    debugger;
    let params = new HttpParams();
    params = params.append('dcountryname', vcoo);
    var value = this.http.get(environment.apiUrl + 'Currency/CheckCountry', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed" || vErrorMsg1 =="") {
          this.isShownError = false;
          this.ErrorMsg = "Country Name doesn't exists. Please select a Valid Country Name from the list.";
          this.Coo = "";
          return false;
        }
        else {
          this.isShownError=true;
        }   
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed" || vErrorMsg1 == "") {
          this.isShownError = false;
          this.ErrorMsg = "Country Name doesn't exists. Please select a Valid Country Name from the list.";
          this.Coo="";
          return false;
        }
        else {
         this.isShownError=true;
        }   
      });
  }

  BindPartsGrid() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    let params = new HttpParams();
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'Part/GetPartsForGrid',{ params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      });
  }

  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  BindPartExport() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    let params = new HttpParams();
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'Part/GetPartsForExport',{ params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.PartsExport = data;

      });
  }

  exportexcel(): void {
    // debugger;
    // /* table id is passed over here */
    // const workSheet = XLSX.utils.json_to_sheet(this.PartsExport);
    // const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    // /* generate workbook and add the worksheet */
    // const wb: XLSX.WorkBook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(wb, workSheet, 'Parts');

    // /* save to file */
    // XLSX.writeFile(wb, "Parts.xlsx");

    let element = document.getElementById('tblHeader');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Parts');

    /* save to file */
    XLSX.writeFile(wb, "Parts.xlsx");

  }

}
